/* eslint-disable */
import { Component, EventEmitter, Input, OnDestroy, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApplicationService, CyberSecuritySecService } from '@pt/api-client';
import {
  SecurityCfg
} from 'it/primatoo/openapi/api/org/schemas/application/getsecurityconfigdetailsresponse/SecurityCfg';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Type } from 'it/primatoo/openapi/api/org/schemas/application/getsecurityconfigdetailsresponse/Type';
import { VendorProductDialogResponse } from './details-security-tool-type-vendor-or-product.component';
import {
  UpdateAppSecurityConfigRequest
} from 'it/primatoo/openapi/api/org/schemas/application/updatesecurityconfigrequest/UpdateAppSecurityConfigRequest';
import { CPE_REGEX, IoniconsFilled, IoniconsOutline, ND, PtPermissions } from '@pt/pt-models';
import { VendorProduct } from 'it/primatoo/openapi/api/org/schemas/application/VendorProduct';
import { Vendor } from 'it/primatoo/openapi/api/sec/schemas/cybersecurity/Vendor';
import { Product } from 'it/primatoo/openapi/api/sec/schemas/cybersecurity/Product';
import {
  GetApplicationForDetailsResponse
} from 'it/primatoo/openapi/api/org/schemas/application/getapplicationfordetailsresponse/GetApplicationForDetailsResponse';
import { AppLinkBuilder } from '../../../utils';
import { NgxPermissionsService } from 'ngx-permissions';
import { TranslateService } from '@ngx-translate/core';
import { HasCveRequest } from 'it/primatoo/openapi/api/sec/schemas/cybersecurity/HasCveRequest';
import { Confirm } from '../../../decorators';

@Component({
  selector: 'pt-details-security-tool-type',
  templateUrl: './details-security-tool-type.component.html',
  styleUrls: ['./details-security-tool-type.component.scss']
})
export class DetailsSecurityToolTypeComponent implements OnDestroy {
  @Input() application!: GetApplicationForDetailsResponse;
  @Input() securityToolType?: Type;
  @Output() changeSecurityToolTypeValue = new EventEmitter<boolean>();
  @ViewChild('dialog', { static: true }) dialog: TemplateRef<unknown>;
  @ViewChild('errorDialog', { static: true }) errorDialog: TemplateRef<unknown>;

  public errorMessage: 'MESSAGE.MISSING_CVE' | 'MESSAGE.FAIL_CHECK_CVE' = 'MESSAGE.MISSING_CVE';
  public readonly dateFormat = 'dd/MM/yyyy HH:mm';

  public readonly ND = ND;
  public cancelSecurityToolId = 'cancelSecurityToolId';
  public IconBuild = IoniconsFilled.build;
  public IconTrash = IoniconsFilled.trash;
  public IconWarning = IoniconsOutline.warning;
  public formGroup: FormGroup;
  public currentCpeForm: FormGroup;
  public securityCfg?: SecurityCfg;
  public Type = Type;
  public isInstructionCollapsed = true;
  public isSupplierCollapsed = true;
  public isVendorProductCollapsed = true;
  public isCVECollapsed = true;

  public loading = false;
  public invalidForm = true;
  public currentBomFileName?: string;
  public currentBomFileError?: string;
  public currentVendor?: Vendor;
  public currentProduct?: Product;
  public currentVersion?: string;
  public currentCpe?: string;
  public currentType?: Type;
  public isChangeVendorOrProduct = false;
  public moduleActive = false;

  private modalRef: NgbModalRef;
  private errorModalRef: NgbModalRef;

  private destroy: Subject<boolean> = new Subject<boolean>();

  constructor(
    private modalService: NgbModal,
    private translateService: TranslateService,
    private cyberSecuritySecService: CyberSecuritySecService,
    private applicationService: ApplicationService,
    private permissionService: NgxPermissionsService
  ) {
    this.currentCpeForm = new FormGroup({
      cpe: new FormControl(null, [Validators.pattern(CPE_REGEX)])
    });
    this.formGroup = new FormGroup({
      option: new FormControl(null)
    });

    this.currentCpeForm.valueChanges.pipe(
      takeUntil(this.destroy)
    ).subscribe(() => {
      this.currentCpe = this.currentCpeForm.controls.cpe.value;
      this.alignForm();
    });

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy)
    ).subscribe(() => {
      this.alignForm();
      this.currentType = this.formGroup.controls.option.value;
    });

    this.moduleActive = !!this.permissionService.getPermission(PtPermissions.ACTIVE_MODULE_CYBERSEC);
  }

  @Confirm({
    title: 'TITLE.REMOVE_VULNERABILITY',
    message: 'MESSAGE.REMOVE_VULNERABILITY'
  })
  removeSecurityToolType() {
    this.invalidForm = true;
    this.applicationService.updateSecurityConfig(this.application.id, {
      securityCfgType: null,
      vendorProduct: null
    }).subscribe({
      next: () => {
        this.invalidForm = false;
        this.modalRef?.close();
        this.changeSecurityToolTypeValue.emit();
      }, error: () => {
        this.invalidForm = false;
        this.modalRef?.close();
        this.changeSecurityToolTypeValue.emit();
      }
    });
  }

  configureSecurityToolType() {
    this.securityCfg = undefined;
    this.currentVendor = undefined;
    this.currentProduct = undefined;
    this.currentVersion = undefined;
    this.currentBomFileName = undefined;
    this.currentCpe = undefined;

    this.applicationService.getSecurityConfig(this.application.id).subscribe({
      next: (response: SecurityCfg) => {
        this.securityCfg = response;

        this.formGroup.setValue({
          option: response.type
        });
        if (response.cpeName) {
          this.currentCpe = response.cpeName;
        }

        if (response.vendorProduct) {
          this.currentVersion = response.vendorProduct.version;
          this.currentProduct = {
            name: response.vendorProduct.productName,
            uuid: response.vendorProduct.product
          };
          this.currentVendor = {
            name: response.vendorProduct.vendorName,
            uuid: response.vendorProduct.vendor
          };
        }

        if (response.bomFileName) {
          this.currentBomFileName = response.bomFileName;
        }

        this.currentCpeForm.controls.cpe.setValue(this.currentCpe, { emitEvent: false });

        this.alignForm();
      }, error: () => {
        this.formGroup.disable();
      }
    });

    this.modalRef = this.modalService.open(this.dialog, {
      centered: true,
      backdrop: 'static',
      size: 'lg'
    });

    setTimeout(() => {
      const doc = document.getElementById(this.cancelSecurityToolId);
      if (doc) {
        doc.focus();
      }
    });

  }

  closeDialog() {
    this.modalRef?.close();
    this.errorModalRef?.close();
    this.loading = false;
  }

  closeErrorDialog() {
    this.errorModalRef?.close();
  }

  save() {
    this.invalidForm = true;
    const securityCfgType: Type = this.formGroup.controls.option.value;
    const vendorProduct: VendorProduct = securityCfgType === Type.VENDOR_PRODUCT ? {
      vendor: this.currentVendor.uuid,
      product: this.currentProduct.uuid,
      vendorName: this.currentVendor.name,
      productName: this.currentProduct.name,
      version: this.currentVersion
    } : undefined;

    const cpeName: string = this.currentCpeForm.controls.cpe.value;

    const request: UpdateAppSecurityConfigRequest = {
      securityCfgType,
      vendorProduct,
      cpeName
    };

    this.loading = true;
    switch (securityCfgType) {
      case Type.CPE:
      case Type.VENDOR_PRODUCT:
        this.applicationService.updateSecurityConfig(this.application.id, request).subscribe({
          next: () => {
            this.processSaveCpeOrVendorAndProduct(request);

            // this.invalidForm = false;
            // this.modalRef?.close();
            // this.changeSecurityToolTypeValue.emit();
            // this.loading = false;
          }, error: () => {
            this.invalidForm = false;
            this.loading = false;
            // this.modalRef?.close();
          }
        });
        break;
      default:
        this.processDefaultSave(request);
    }


    // this.applicationService.updateSecurityConfig(this.application.id, request).subscribe({
    //   next: () => {
    //     switch (securityCfgType) {
    //       case Type.CPE:
    //         this.checkValidCVE(request);
    //         this.invalidForm = false;
    //         break;
    //       case Type.VENDOR_PRODUCT:
    //         this.checkValidVendorProduct(request);
    //         this.invalidForm = false;
    //         break;
    //       default:
    //         this.invalidForm = false;
    //         // CHIUDO LA MODALE
    //         this.modalRef?.close();
    //         // this.configureSecurityToolType();
    //         // RIAVVIO LA PAGINA DI DETTAGLI
    //         this.changeSecurityToolTypeValue.emit();
    //         this.loading = false;
    //     }
    //   }, error: () => {
    //     this.invalidForm = false;
    //     this.loading = false;
    //     // this.modalRef?.close();
    //     // this.configureSecurityToolType();
    //     // this.changeSecurityToolTypeValue.emit();
    //   }
    // });
  }

  ngOnDestroy(): void {
    if (this.modalRef) {
      this.modalRef.close();
    }
    this.destroy.next(true);
  }

  updateVendorProduct(response: VendorProductDialogResponse) {
    this.currentProduct = response.product;
    this.currentVendor = response.vendor;
    this.currentVersion = response.version;
    this.alignForm();
  }

  openCPE() {
    this.isInstructionCollapsed = true;
    this.isVendorProductCollapsed = true;
    this.isSupplierCollapsed = true;
    this.isCVECollapsed = false;
  }

  /**
   * Prodotto a scaffale
   */
  openVendorProduct() {
    this.isInstructionCollapsed = true;
    this.isVendorProductCollapsed = false;
    this.isSupplierCollapsed = true;
    this.isCVECollapsed = true;
  }

  /**
   * Software sviluppato internamente/fornitore
   */
  openBOM() {
    this.isInstructionCollapsed = true;
    this.isVendorProductCollapsed = true;
    this.isSupplierCollapsed = false;
    this.isCVECollapsed = true;
  }

  uploadBom($event: File) {
    this.currentBomFileError = undefined;
    this.currentBomFileName = undefined;
    this.applicationService.uploadBom(this.application.id, $event).subscribe({
      next: () => {
        this.currentBomFileName = $event.name;
        this.alignForm();
      }, error: (e) => {
        if (e?.error?.reason) {
          this.currentBomFileError = e?.error?.reason;
        } else {
          this.translateService.stream('MESSAGE.BOM_INVALID_FILE').subscribe((message) => {
            this.currentBomFileError = message;
          });

        }
        this.currentBomFileName = undefined;
        this.alignForm();
      }
    });
  }

  navigateToUser(authorId?: number) {
    if (authorId) {
      window.open(AppLinkBuilder.linkOfEntity('users', authorId), '_blank');
    }
  }

  private alignForm() {

    const optionValue: Type | undefined = this.formGroup.controls.option.value;

    this.invalidForm = true;
    switch (optionValue) {
      // Software sviluppato internamente/fornitore
      case Type.BOM:
        this.openBOM();
        if (this.currentBomFileName) {
          this.invalidForm = false;
        }
        break;

      // Prodotto a scaffale
      case Type.VENDOR_PRODUCT:
        this.currentBomFileError = undefined;
        this.openVendorProduct();
        if (!!this.currentVendor && !!this.currentProduct && !!this.currentVersion) {
          this.invalidForm = false;
        }
        break;
      case Type.CPE:
        this.openCPE();
        this.invalidForm = this.currentCpeForm.invalid;
        // if (this.currentCpe?.length > 0) {
        //   this.invalidForm = false;
        // }
        break;

      // Software monitorato tramite altro strumento
      case Type.EXT:
        this.currentBomFileError = undefined;
        this.isInstructionCollapsed = true;
        this.isVendorProductCollapsed = true;
        this.isSupplierCollapsed = true;
        this.isCVECollapsed = true;
        this.invalidForm = false;
        break;
    }

    this.isChangeVendorOrProduct =
      optionValue !== this.securityCfg.type
      || this.securityCfg?.vendorProduct?.vendor !== this.currentVendor?.uuid
      || this.securityCfg?.vendorProduct?.product !== this.currentProduct?.uuid
      || this.securityCfg?.vendorProduct?.version !== this.currentVersion
      || this.securityCfg?.cpeName !== this.currentCpe
      || (!!this.currentBomFileName && this.securityCfg?.bomFileName !== this.currentBomFileName)
    ;

  }

  private missingCVE() {
    this.errorMessage = 'MESSAGE.MISSING_CVE';
    this.errorModalRef = this.modalService.open(this.errorDialog, {
      centered: true,
      backdrop: 'static',
      size: 'md'
    });
    this.loading = false;
  }

  private failCheckCVE() {
    this.errorMessage = 'MESSAGE.FAIL_CHECK_CVE';
    this.errorModalRef = this.modalService.open(this.errorDialog, {
      centered: true,
      backdrop: 'static',
      size: 'md'
    });
    this.loading = false;
  }

  private processSaveCpeOrVendorAndProduct(request: UpdateAppSecurityConfigRequest) {

    switch (true) {
      case request.securityCfgType === Type.CPE && !!request.cpeName:
        const cpeRequest: HasCveRequest = {
          cpe: request.cpeName
        };
        this.cyberSecuritySecService.checkVendorAndProduct(cpeRequest)
          .subscribe((r) => {
            if (r.hasCve) {
              this.invalidForm = false;
              this.modalRef?.close();
              this.changeSecurityToolTypeValue.emit();
              this.loading = false;

              // this.processDefaultSave(request);
            } else {
              this.invalidForm = false;
              this.modalRef?.close();
              this.changeSecurityToolTypeValue.emit();
              this.loading = false;
              this.missingCVE();
            }
          }, () => {
            this.failCheckCVE();
          });
        break;

      case request.securityCfgType === Type.VENDOR_PRODUCT && !!request.vendorProduct:
        const vpRequest: HasCveRequest = {
          params: {
            vendorName: request.vendorProduct.vendorName,
            productName: request.vendorProduct.productName,
            version: request.vendorProduct.version
          }
        };
        this.cyberSecuritySecService.checkVendorAndProduct(vpRequest)
          .subscribe((r) => {
            if (r.hasCve) {
              this.invalidForm = false;
              this.modalRef?.close();
              this.changeSecurityToolTypeValue.emit();
              this.loading = false;

              // this.processDefaultSave(request);
            } else {
              this.invalidForm = false;
              this.modalRef?.close();
              this.changeSecurityToolTypeValue.emit();
              this.loading = false;
              this.missingCVE();
            }
          }, () => {
            this.failCheckCVE();
          });
        break;
      default:
        this.loading = false;
    }
  }

  private processDefaultSave(request: UpdateAppSecurityConfigRequest) {
    this.applicationService.updateSecurityConfig(this.application.id, request).subscribe({
      next: () => {
        this.invalidForm = false;
        this.modalRef?.close();
        this.changeSecurityToolTypeValue.emit();
        this.loading = false;
      }, error: () => {
        this.invalidForm = false;
        this.loading = false;
        this.modalRef?.close();
      }
    });
  }
}
